import { render, staticRenderFns } from "./EventsLayout.vue?vue&type=template&id=8b7e2482&scoped=true&"
import script from "./EventsLayout.vue?vue&type=script&lang=js&"
export * from "./EventsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7e2482",
  null
  
)

export default component.exports